import { makeStyles } from '@mui/styles';
import React from 'react';

import NoContent from '../../../../components/NoContent';
import withTranslation from '../../../../components/withTranslation';

const useStyles = makeStyles({
  iframe: {
    border: 0,
    minHeight: '780px',
  },
  container: {
    marginBottom: '30px',
  },
  error: {
    textAlign: 'center',
  },
});

const DashboardPartEmbedded = ({ tab, translateString }) => {
  const classes = useStyles();

  const { embeddedUrl, title } = tab.graph;

  return (
    <div className={classes.container}>
      {embeddedUrl ? (
        <iframe
          title={title ?? translateString('Embedded content')}
          src={embeddedUrl}
          className={classes.iframe}
          width="100%"
          height="100%"
        />
      ) : (
        <NoContent message={translateString('No content available to display')} />
      )}
    </div>
  );
};

export default withTranslation(DashboardPartEmbedded);
